import CustomListItem from '../../../components/CustomListItem';
import Subtitle from '../../../components/Header/Subtitle';
import FunctionalityAttributeList from '../Functionality/AttributeList';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AttributesList = ({ handleDragStart, t }) => {
    const { attributes } = FunctionalityAttributeList({});

    return (
        <div className='my-5'>
            <Subtitle name={'attributes'} />
            <div className='template-attributes-list mt-3'>
                {attributes.map((attribute, index) => (
                    <CustomListItem
                        key={index}
                        index={index + 1}
                        classes='custom-class'
                        id={`btn-ct-${attribute.id}`}
                        children={
                            <div
                                className='d-flex align-items-center mt-1'
                                draggable
                                onDragStart={(e) => handleDragStart(e, 'textTemplate', null, null, attribute.id)}
                            >
                                <img className='mx-2' src={attribute.icon} alt={attribute.label} />
                                <h4>{t(attribute.label)}</h4>
                            </div>
                        }
                    />
                ))}
            </div>
        </div>
    );
};

export default AttributesList;
